export { SortDescending as default } from './SortDescending';
